import { RouteObject } from 'react-router-dom';

import liveChatRoutes from './modules/live-chat/liveChatRoutes';
import tailorRoutes from './modules/tailor/tailorRoutes';
import virtualAssistantRoutes from './modules/virtual-assistant/virtualAssistantRoutes';

export const routes: RouteObject[] = [...tailorRoutes, ...liveChatRoutes, ...virtualAssistantRoutes];
